import { useTheme } from "../styles/theme";

export default function StatCard({ label, value, color, icon, big, sub }) {
  const S = useTheme();
  return (
    <div
      style={{
        ...S.statCard,
        ...(big ? S.statCardBig : {}),
        borderColor: color + "44",
      }}
    >
      <div style={S.statIcon}>{icon}</div>
      <div style={{ ...S.statValue, color }}>{value}</div>
      <div style={S.statLabel}>{label}</div>
      {sub && <div style={S.statSub}>{sub}</div>}
    </div>
  );
}
